var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 98,
    height: 80,
    viewBox: "0 0 98 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.78 0.374201C49.3797 -0.124734 48.6203 -0.124733 48.22 0.374202L44.2422 5.33204C44.2123 5.36931 44.1856 5.4076 44.1621 5.44668H8C3.58172 5.44668 0 9.0284 0 13.4467V71.9972C0 76.4155 3.58172 79.9972 8 79.9972H90C94.4183 79.9972 98 76.4155 98 71.9972V13.4467C98 9.0284 94.4183 5.44668 90 5.44668H53.8379C53.8144 5.4076 53.7877 5.36931 53.7578 5.33204L49.78 0.374201Z",
    fill: "#535353"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnion);
export default __webpack_public_path__ + "static/media/union.b52b3e8e210d95bcbd933af0ecf0d5a6.svg";
export { ForwardRef as ReactComponent };